import React from 'react';
import Item from './Item';

export default class List extends React.Component {
	constructor (props) {
		super(props);
		this.index = 0;
	}
	render () {
		const { attractions, isMedieval } = this.props;

		return (
			<div className="w-full relative flex flex-wrap justify-between">
				{attractions.map((attraction, i) => {
					if (i === 0) this.index = 0; // reset if props changes and loop restarts
					const style = this.index === 0 ? 'full' : 'half';

					const comp = <Item styleIndex={this.index} style={style} key={attraction.id} attraction={attraction} isMedieval={isMedieval} />;

					// update index after rendering component (comp)
					this.index = this.index < 2 ? this.index + 1 : 0;

					return comp;
				})}
			</div>
		);
	}
}
